import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { Server2 } from "../redux/actions/auth/auth.actions";
import axios from "axios";

const RedirectPage = () => {
  const [searchParams] = useSearchParams();
  const refid = searchParams.get("refid");
  const [browserId, setBrowserId] = useState("");
  const [ip, setIp] = useState("");
  const {name} = useParams();

  useEffect(() => {

     fetch("https://geo.ipify.org/api/v2/country?apiKey=at_HszncLMwg8pHr1RHzBYg5l0dtD1q4")
      .then((res) => res.json())
      .then((data) => {
        setIp(data.ip);
      })
      .catch((err) => console.error(err));
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setBrowserId(result.visitorId);
    };

    loadFingerprint();

  }, []);


  useEffect(() => {

    if(ip !== "" && browserId !== "" && refid !== ""){
      affliate()
    }

  }, [ip, browserId])

  const affliate = () => {
    
    if(ip !== "" && browserId !== ""){
      var config = {
        method: "post",
        url: Server2 + `/affiliates/clicked`,
        data: {
          ip: ip,
          browserId: browserId,
          refId: refid,
          name: name
        }
      };

      console.log(config.data)
  
      axios(config).then(function (response) {
    
        if(response.data.status === 200) window.location.href = "https://apps.apple.com/us/app/ibouge/id1635413317"
        console.log(response, 'affiliate response Db')
    
      }).catch(function (error) {
        console.log(error);
      });
    }

  }


  return;
};

export default RedirectPage;